/** 실행 상태 아이콘 — 모양과 색은 상태 표현 정본(runStatusView)에서, 크기·여백은 화면이 정한다 */
import type { SvgIconProps } from '@mui/material';
import type { SimStatus } from '@/types/simulation';
import { RUN_STATUS_VIEW } from './runStatusView';

export function RunStatusIcon({ status, ...props }: { status: SimStatus } & Omit<SvgIconProps, 'color'>) {
  const { Icon, tone } = RUN_STATUS_VIEW[status];
  return <Icon color={tone} data-status={status} {...props} />;
}
